(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["material-shop"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-material-calculator]').forEach((form)=>{form.addEventListener('submit',(event)=>{event.preventDefault();const width=Number(form.querySelector('[name="width"]').value);const length=Number(form.querySelector('[name="length"]').value);const result=form.querySelector('[data-material-result]');if(!Number.isFinite(width)||!Number.isFinite(length)||width<=0||length<=0){result.textContent='Bitte gib für beide Maße einen Wert größer als null ein.';return;}const area=(width*length)/10000;result.textContent='Benötigte Fläche: '+area.toLocaleString('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2})+' m². Verschnitt und Rollenbreite bitte separat prüfen.';});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdm-designer-reveal"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=root=>{if(root.dataset.demoReady)return;root.dataset.demoReady='true';const range=root.querySelector('[data-demo-range]'),stage=root.querySelector('.pdm-demo__stage'),progress=root.querySelector('[data-demo-progress]');const update=()=>{const value=Math.min(100,Math.max(0,Number(range.value)||0));stage.style.setProperty('--demo-reveal',value+'%');progress.textContent=value+' %';range.setAttribute('aria-valuetext',value+' %');};range.addEventListener('input',update);range.addEventListener('change',update);update();const dialog=root.querySelector('[data-demo-dialog]');if(dialog){const opener=root.querySelector('[data-demo-zoom]'),target=root.querySelector('[data-demo-zoom-art]');opener.addEventListener('click',()=>{const clone=root.querySelector('[data-demo-art]>svg').cloneNode(true);clone.querySelectorAll('[id]').forEach(node=>{const old=node.id,next=old+'-zoom';clone.querySelectorAll('*').forEach(child=>[...child.attributes].forEach(attr=>{if(attr.value.includes('url(#'+old+')'))child.setAttribute(attr.name,attr.value.replaceAll('url(#'+old+')','url(#'+next+')'));}));node.id=next;});target.replaceChildren(clone);dialog.showModal();});root.querySelector('[data-demo-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>opener.focus({preventScroll:true}));}};document.querySelectorAll('[data-designer-demo]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-designer-demo]').forEach(init));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdm-surface-reveal"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=root=>{if(root.dataset.revealReady)return;root.dataset.revealReady='true';const range=root.querySelector('.pdm-surface-reveal__range'),stage=root.querySelector('.pdm-surface-reveal__stage'),progress=root.querySelector('[data-surface-progress]');const update=()=>{const value=Math.max(0,Math.min(100,Number(range.value)||0));stage.style.setProperty('--reveal',value+'%');progress.textContent=value;range.setAttribute('aria-valuetext',value+' Prozent der Fläche gestaltet');};range.addEventListener('input',update);range.addEventListener('change',update);update();};document.querySelectorAll('[data-surface-reveal]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-surface-reveal]').forEach(init));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services"] && !Shopify.designMode) return;
  try {
    
(() => {
  const section = document.querySelector('#leistungen');
  const bird = section?.querySelector('.service-overview__bird');
  const buttons = section?.querySelector('.pdm-category-nav');
  const rails = document.querySelector('.pdm-plotter-background > g > path');
  if (!bird || !buttons || !rails || bird.dataset.positionReady) return;
  bird.dataset.positionReady = 'true';
  if ('IntersectionObserver' in window) {
    const visibility = new IntersectionObserver(entries => {
      bird.toggleAttribute('data-bird-paused', !entries[0].isIntersecting);
    });
    bird.setAttribute('data-bird-paused', '');
    visibility.observe(bird);
  }
  const position = () => {
    if (window.innerWidth <= 990) { bird.style.removeProperty('--pdm-bird-offset'); return; }
    const bounds = bird.getBoundingClientRect();
    const offset = parseFloat(getComputedStyle(bird).top) || 0;
    const midpoint = (rails.getBoundingClientRect().bottom + buttons.getBoundingClientRect().top) / 2;
    const next = Math.round(offset + midpoint - bounds.top - bounds.height / 2);
    if (Math.abs(next - offset) > .5) bird.style.setProperty('--pdm-bird-offset', next + 'px');
  };
  let positionFrame = 0;
  const schedulePosition = () => {
    if (positionFrame) return;
    positionFrame = requestAnimationFrame(() => {
      positionFrame = 0;
      position();
    });
  };
  const observer = new ResizeObserver(schedulePosition);
  observer.observe(section.querySelector('.service-overview__head'));
  observer.observe(buttons);
  if (rails.ownerSVGElement) observer.observe(rails.ownerSVGElement);
  window.addEventListener('resize', schedulePosition, { passive: true });
  schedulePosition();
  document.addEventListener('shopify:section:unload', event => {
    if (!event.target.contains(section)) return;
    observer.disconnect();
    cancelAnimationFrame(positionFrame);
    window.removeEventListener('resize', schedulePosition);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
